import React, { useEffect, useContext } from 'react'
import PropTypes from 'prop-types'

import { Play } from '@aok/icon-functional'
import { TextBlock } from '@aok/text-elements'
import { PrimaryButton } from '@aok/ui-elements'

import { PrivacyContext } from '../../../context/PrivacyContext'

import FallbackImage from '../../../images/fallback-aok-small.png'

const VideoPrivacyOverlay = React.forwardRef(
  ({ errorMessage, previewImage, playerType, onPlayVideo, onConfirmPrivacyNotice }, ref) => {
    const privacyContext = useContext(PrivacyContext)

    // Check if the video is a kaltura video, because the privacy overlay is not needed for kaltura videos
    useEffect(() => {
      if (playerType === 'kaltura') {
        onPlayVideo()
      }
    }, [onPlayVideo, playerType])

    //  background
    const BGImage = () => {
      return (
        <div
          className="absolute top-0 left-0 right-0 bottom-0 w-full h-full bg-no-repeat bg-cover scale-120"
          style={{
            backgroundImage: `url("${previewImage ? previewImage?.variants[0]?.url : FallbackImage}")`,
            filter: 'blur(4px)',
          }}
        />
      )
    }

    // Data security popover
    const DataSecurityPopover = () => {
      return (
        <>
          <div className="bg-ffffff rounded-4 flex flex-col items-center relative mx-16 my-12 px-24 py-32 600:w-10/12 600:px-24 840:w-13/18 1280:w-5/9">
            <TextBlock
              text={errorMessage ? errorMessage : privacyContext?.video?.text}
              className="text-center hyphens"
            />

            <PrimaryButton
              onClick={() => {
                onPlayVideo()
                onConfirmPrivacyNotice()
              }}
              isDisabled={!!errorMessage}
              className="w-full mx-auto relative mt-24 600:mt-32 600:w-auto"
            >
              <Play className="fill-current w-16 h-16 mr-8" />
              Video anzeigen
            </PrimaryButton>
          </div>
        </>
      )
    }

    return (
      <div
        ref={ref}
        className="video-privacy-overlay relative flex flex-col justify-center items-center overflow-hidden min-h-328 600:min-h-400 840:min-h-346 1280:min-h-450"
      >
        <BGImage />
        <DataSecurityPopover />
      </div>
    )
  }
)

VideoPrivacyOverlay.propTypes = {
  errorMessage: PropTypes.string,
  previewImage: PropTypes.object,
  onPlayVideo: PropTypes.func,
  onConfirmPrivacyNotice: PropTypes.func,
}

VideoPrivacyOverlay.defaultProps = {
  onPlayVideo: () => {},
  onConfirmPrivacyNotice: () => {},
}

export default VideoPrivacyOverlay
